'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import TechnologyFaq from '@/components/technologies/technology-faq';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import DjangoFAQ from '@/components/faqs/django-faq';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DjangoServies from '@/components/technologies/django-demand';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Maximize the full potential of Django by choosing dynamic Python web development with reduced development time. With custom solutions built using Django Development Services, we bring innovation to every business industry."
                alt="Django Development"
                title="Django Development"
                width={1073}
                height={604}
                path={'django-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                Django<div>Development Company</div>
            </TechHero>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Django" />
            <ContetVideoSection title="Empower Your Business with Python-based Django Development">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Django is an open-source and powerful Python framework following an MVT (Model View Template) type of
                        architecture. Our team of Django is acquainted with the Django tech stack including MVT, ORM,
                        Authentication, CSRF, XSS, DRF, Signals, Response lifecycle, Middleware, and more.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        Moweb is a Django development company specializing in Python/Django web development to give your business
                        the desired results. Our deep knowledge of Python and Django development helps us to provide you with
                        quality-driven and scalable custom development of Django web apps. Whether you want a website, a web app,
                        an eCommerce platform, or a customer portal, our custom Django development solutions are enough to
                        skyrocket your business.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        We leverage our extensive Python development experience to your business, from consulting to migrating
                        your solution to Django and testing your Django applications. We take pride in providing our clients with
                        the ideal blend of scalability, adaptability, and flexibility. Our team is up-to-date on the latest
                        technologies and agile methodologies, and we offer a diverse solution portfolio.
                    </p>
                </>
            </ContetVideoSection>
            <DjangoServies />
            <HireProcess
                bg="bg-django"
                pageTitle="Hire Django Developers To Steer Your Business Into The New"
                desc="Schedule a free consultation with our Python experts to build a reliable, feature-rich Django application that gives us an edge over our competitors."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For Django Web Development With Python?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Django Developers"
                desc="Select from different engagement models to hire Django Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <TechnologyFaq title="FAQs On Django Development Services" bg="bg-django">
                <DjangoFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
